import { post } from './axios.js'

let api = '/api'

export const addMessage = data => post(api + '/addMessage', data)
